<template>
  <header class="header mb-md-5">
    <iframe
      id="header"
      :src="standaloneHeaderUrl"
      width="100%"
      height="58px"
      seamless="seamless"
      frameborder="0"
      scrolling="no"></iframe>
  </header>
</template>
<script>

export default {
  name: 'global-header',
  data: function () {
    return {
      standaloneHeaderUrl: dconf.GLOBAL_STANDALONE_HEADER_URL
    };
  },
  mounted() {
    if (appEnv !== 'dev') {
      this.standaloneHeaderUrl = `${this.publication.zephrCDN}${this.standaloneHeaderUrl}`;
    }
    console.log(`Header url: ${this.standaloneHeaderUrl}`);
    const app = this;
    function eventHandler(event) {
      if (event && event.data) {
        const data = event.data;
        if (data['header-height'] !== undefined) {
          app.setHeight(data);
        }
        if (data['header-is-flyout-open'] !== undefined) {
          app.setFlyout(data);
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', eventHandler, false);
    } else {
      window.attachEvent('onmessage', eventHandler);
    }
  },
  methods: {
    setHeight(data) {
      const height = data['header-height'];
      const header = document.getElementById('header');
      header.setAttribute('height', height);
    },
    setFlyout(data) {
      const isFlyoutOpen = data['header-is-flyout-open'];
      const root = document.getElementsByTagName('html')[0];

      if (isFlyoutOpen) {
        root.className += ' is-flyout-open';
      } else {
        root.className = root.className.replace(/(?:^|\s)is-flyout-open(?!\S)/g, '');
      }
    }
  }
};
</script>
